import { render } from "./ModalTips.vue?vue&type=template&id=3a2aa623"
import script from "./ModalTips.vue?vue&type=script&lang=js"
export * from "./ModalTips.vue?vue&type=script&lang=js"
script.render = render

export default script